import { inject } from '@angular/core';
import type { HttpRequest, HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
import { HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ErrorMappingRegistryService } from '@core/error-handler/services/error-mappings/error-mapping-registry.service';
import { ErrorHandlerService } from '@core/error-handler/services/error-handler.service';
import type { SuccessResponseBody } from './models/success-response.model';

export const successResponseHandlerInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const errorMappingRegistry = inject(ErrorMappingRegistryService);
  const errorHandler = inject(ErrorHandlerService);

  return next(req).pipe(
    map((event) => {
      // We're only interested in HttpResponse events
      if (!(event instanceof HttpResponse)) {
        return event;
      }

      // Check if the response body has an isSuccess property
      const body = event.body as SuccessResponseBody | null;

      if (!body || typeof body.isSuccess !== 'boolean' || body.isSuccess !== false) {
        return event;
      }

      const errorCode = body.errorCode || null;
      const errorMessage = body.errorMessage || null;

      // Get the appropriate error using our mapping registry
      const appError = errorMappingRegistry.getErrorForSuccessResponse(
        req.url,
        errorCode,
        errorMessage
      );

      if (appError.showInInterceptor) {
        errorHandler.handleError(appError);
      } else {
        // Pass the error to the component for handling
        return event.clone({
          body: {
            ...body,
            _appError: appError
          }
        });
      }

      return event;
    })
  );
};
